// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3105":"e3a7d9687dbce904","4934":"d031035ee98c6268","5023":"aeead2b992b0ea1f","6531":"07501d711036de13","8568":"a465c38adf85a1f8"}[chunkId] + ".js";
};